import css from './NoElements.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { IWalletScreen } from 'meta/pages/v4/wallet'

import { ButtonRed } from 'components/Actions/Action'
import { GridColumn } from 'components/Layout/Grid'
import Img from 'components/Media/Img'

interface Props {
  activeScreen: IWalletScreen
}

const NoElements: React.FC<Props> = (props) => {
  const { activeScreen } = props

  const { t } = useTranslation()

  return (
    <GridColumn gridColumnStart={1} gridColumnEnd={17} className={css.wrapper}>
      <div className={css.noTickets}>
        <Img className={css.caption} src={`/wallet/no_tickets_caption.svg`} />
        <div className={css.title}>
          {t(activeScreen == IWalletScreen.tickets ? 'wallet:no_tickets_title' : 'wallet:no_extra_title')}
        </div>
        <div className={css.description}>
          {t(activeScreen == IWalletScreen.tickets ? 'wallet:no_tickets_desc' : 'wallet:no_extra_desc')}
        </div>
        <ButtonRed
          className={css.refreshBtn}
          onClick={() => {
            window.location.reload()
          }}
        >
          <div>{t('wallet:refresh_page')}</div>
        </ButtonRed>
      </div>
    </GridColumn>
  )
}

export default NoElements
